import { Tooltip } from '@domain-group/fe-blueprint-ui/tooltip';
export default Tooltip;